<template>
<div class="docSign_list">
    <div class="docSign_content">
        <div class="tit">接收文书</div>
        <template v-if="receiveDocumentList.length">
            <template v-for="(doc,index) in receiveDocumentList">
                <el-card :key="index" class="box-card" shadow="hover">
                    <div slot="header" class="doc_list_head">
                        <span>{{booktype[doc.sign]}}</span>
                    </div>
                    <div class="doc_item">
                        <el-row :gutter="20">
                            <el-col :span="20"><span class="doc_name"><i class="el-icon-document"></i> {{doc.fileName}}</span></el-col>
                            <el-col :span="4">
                                <el-button type="text" @click="downfile(doc,false)">下载</el-button>
                                <el-button type="text" @click="preview(doc,false)">预览</el-button>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </template>
        </template>
        <template v-else>
            <el-card class="box-card" shadow="hover">
                <div class="text item">暂无文书</div>
            </el-card>
        </template>
    </div>
</div>
</template>

<script>
import {documentList, getUserOnlineDocList} from "../../../api/casespace";
import config from '@/config/config'
import filedownload from '@/api/filedown.js'
import {getStore} from "../../../utils/utils";

export default {
    components: {
    },
    data() {
        return {
            receiveDocumentList: [],
            booktype: {
                "GZZC_SD_PROOF_NOTICE": "受理通知书、风险和举证通知书",
                "GZZC_SD_APPLY_BOOT": '应诉通知书、风险和举证通知书，申请书副本及证据材料',
                "GZZC_SD_TRIAL_NOTICE_BOOK": '开庭通知书',
                "GZZC_SD_AWARD_COPY": '裁决书（副本）',
                "GZZC_SD_MEDIATION_BOOK_COPY": '调解书（副本）',
                "GZZC_SD_DECISION_BOOK_COPY": '决定书（副本）',
                "GZZC_SD_OTHER_MATERIAL": '其他材料',
                "GZZC_MEDIATION": "调解书",
                "GZZC_MEDIATION_RECORDS": '调解笔录',
                "GZZC_BACKOUT_APPLY_TABLE": '回仲裁申请表',
                "GZZC_BACKOUT_DECISION_BOOK": '撤诉决定书',
                "GZZC_PUBLIC_SERVICE_RECEIPT": '送达回证',
                "GZZC_OTHER": '其他',
                "GZZC_MEDIATION_STAMP": '调解书(盖章版)',
                "GZZC_BACKOUT_DECISION_BOOT_STAMP": '撤诉决定书(盖章版)',
            },
        }
    },
    watch: {
    },
    created() {
        this.curRoomId = this.$route.query.meetingid
        this.getDocumentList()
    },
    mounted() {
    },
    methods: {
        getDocumentList() {
            if (this.$route.query.spaceType == 1) {
                documentList({
                    "meetingId": this.curRoomId,
                    "objectType": "MEDIATION"
                }).then(res => {
                    if (res.data.code === 1000) {
                        this.receiveDocumentList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                }).catch(err => {
                    this.$message({
                        type: 'error',
                        message: err
                    })
                })
            } else {
                getUserOnlineDocList({
                    "meetingId": this.curRoomId,
                }).then(res => {
                    if (res.data.code === 1000) {
                        let loginInfo = JSON.parse(getStore('loginInfo'));
                        if (!loginInfo.email) {
                            // 无预留邮箱  屏蔽送达回证
                            this.receiveDocumentList = []
                            res.data.data.forEach(item => {
                                if (item.sign != "GZZC_PUBLIC_SERVICE_RECEIPT") {
                                    this.receiveDocumentList.push(item)
                                }
                            })
                        } else {
                            this.receiveDocumentList = res.data.data
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                }).catch(err => {
                    this.$message({
                        type: 'error',
                        message: err
                    })
                })
            }
        },
        deletefile(doc) {
            let params = {docId : doc.docId}
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            delFileByMediatorApi(params).then(res => {
                loading.close()
                if (res.data.code === 1000) {
                    this.$message.success('已成功删除')
                    // 刷新列表
                    this.loadPage()
                } else {
                    this.$message('删除失败')
                }
                console.log(res)
            }).catch(err => {
                loading.close()
                this.$message('删除失败')
                console.log(err)
            })
            console.log(doc)
        },
        downfile(doc, type) {
            if (type) {
                filedownload('/gzzc/docBook/clerkRecordDownload', {
                    fileId: doc.attachFileId,
                    id: doc.attachId
                }, doc.attachFileName)
            } else {
                filedownload('/gzzc/docBook/clerkRecordDownload', {
                    fileId: doc.fileId,
                    id: doc.id
                }, doc.fileName)
            }
        },
        preview(doc, type) {
            if (type) {
                window.open(config.baseURL + '/gzzc/docBook/previewImg/' + doc.attachFileId)
            } else {
                window.open(config.baseURL + '/gzzc/docBook/previewImg/' + doc.fileId)
            }
        },
    }
}
</script>

<style lang="scss">
.docSign_list {
    margin: 26px 40px 20px 65px;

    .docSign_content {
        .box-card {
            margin-bottom: 12px;
        }

        padding-bottom: 40px;

        .tit {
            font-size: 20px;
            color: #333333;
            position: relative;
            padding-left: 12px;
            margin-bottom: 30px;

            &:before {
                position: absolute;
                content: '';
                width: 4px;
                height: 20px;
                background-color: #1e6dcb;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
            }
        }

        .el-card__header {
            padding: 10px 20px;
            background-color: #f8f9fa;

            span {
                font-size: 14px;
            }
        }

        .doc_item {
            line-height: 32px;

            .doc_name {
                font-size: 14px;
            }

            .el-tag {
                margin-right: 8px;
            }
        }
    }

    .docSign_foot {
        text-align: center;

        .el-button {
            color: #fff;
        }
    }

    .docSign_foot_block {
        width: 100%;
        height: 80px;
        margin-top: 20px;
        font-size: 16px;
        border-top: 1px solid #EBEEF5;
        display: flex;
        align-items: center;

        .left {
            margin-left: 10px;
        }

        .resign {
            margin-left: 20px;
            text-decoration: underline;
            color: #1e6dcb;
            cursor: pointer;
        }

        .signImg {
            width: 120px;
            margin-left: 10px;
        }
    }
}

.booksign_dialog {
    .booksign_content {
        text-align: center;
        font-size: 16px;

        i.sign-icon-warning {
            display: block;
            margin: 0 auto 20px;
            width: 56px;
            height: 56px;
            background: url("~@/assets/images/ico-sign_warning.png")
        }

        i.sign-icon-wrong {
            display: block;
            margin: 0 auto 20px;
            width: 56px;
            height: 56px;
            background: url("~@/assets/images/ico-sign_wrong.png")
        }
    }

    .dialog-footer {
        display: inline-block;
        padding-bottom: 20px;

        .el-button {
            min-width: 120px;
            height: 40px;
        }
    }

    .el-button+.el-button {
        margin-left: 40px;
    }
}
</style>
